import React, { useEffect, useState } from "react";
import serviceImage1 from "../../../Assets/Home/Service/service1.png";
import serviceImage2 from "../../../Assets/Home/Service/service2.png";
import serviceImage3 from "../../../Assets/Home/Service/service3.png";
import { FaFlask, FaMicroscope, FaVial, FaCapsules } from "react-icons/fa";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import lab6 from "../../../Assets/Home/Lab/lab6.svg";
import lab7 from "../../../Assets/Home/Lab/lab7.svg";
import lab8 from "../../../Assets/Home/Lab/lab8.svg";
import lab9 from "../../../Assets/Home/Lab/lab9.svg";
import lab10 from "../../../Assets/Home/Lab/lab10.svg";
import ServiceSkeleton from "../../AdminComponents/service/ServiceSkeleton";

const serviceImages = [lab6, lab7, lab8, lab9, lab10];
const Services = () => {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/service/get-all-services`,
      );
      if (response.data.success) {
        setServices(response.data.services);
      }
    } catch (err) {
      console.error("Error fetching services:", err);
      setError("Failed to load services");
    } finally {
      setLoading(false);
    }
  };

  const handleReadMore = (serviceId) => {
    navigate(`/service/${serviceId}`);
    window.scrollTo(0, 0);
  };

  // Fallback icons if no icon in service data
  const getIcon = (index) => {
    const icons = [
      <FaFlask size={28} />,
      <FaMicroscope size={28} />,
      <FaVial size={28} />,
      <FaCapsules size={28} />,
    ];
    return icons[index % icons.length];
  };

  if (loading) {
    return <ServiceSkeleton />;
  }

  if (error) {
    return (
      <div className="pb-10 familjen-font">
        <div className="min-h-[50vh] flex items-center justify-center px-4">
          <div className="max-w-md w-full text-center animate-fade-in">
            <div className="mx-auto w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-6 animate-bounce-gentle">
              <div className="relative">
                <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-3">Oops! Something Went Wrong</h2>

            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 animate-pulse-soft">
              <p className="text-red-700 text-sm font-medium">
                {error || "We're having trouble loading this content. This might be temporary."}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-red-500 text-white rounded-lg font-medium hover:bg-red-600 transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                🔄 Try Again
              </button>
            </div>
            <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-blue-800 text-sm">
                <strong>Need help?</strong> Contact support at{" "}
                <a href="mailto:support@example.com" className="underline hover:text-blue-600">
                  support@example.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-primaryColor py-16 md:px-10 px-6">
      <div className="text-white text-center xl:w-[50%] mx-auto py-10 familjen-font">
        <h1 data-aos="fade-up" data-aos-duration="700" className="text-lg font-semibold text-white uppercase">
          Our Services
        </h1>
        <p data-aos="fade-up" data-aos-duration="700" className="text-white md:text-5xl text-4xl font-semibold capitalize mb-4">
          Comprehensive Solutions For{" "}
          <span className="text-black"> Every Challenge.</span>
        </p>
      </div>

      <div className="flex items-stretch flex-nowrap overflow-x-auto gap-8 snap-x snap-mandatory rounded-2xl overflow-hidden transition-all duration-300">
        {services.map((service, index) => {
          // pick image in serial, looping back after 5
          const selectedImage = serviceImages[index % serviceImages.length];

          return (
            <div
              data-aos="zoom-in-up"
              key={service._id}
              className="bg-white shrink-0 w-full sm:w-[48%] md:w-[45%] lg:w-[30%] xl:w-[23%] snap-center rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300"
            >
              {/* Top Image */}
              <div className="h-56 w-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Hexagon Icon */}
              <div data-aos="fade-up" data-aos-duration="700" className="flex justify-center -mt-10">
                <div className="bg-primaryColor text-white p-4 rounded-lg transform rotate-45 w-16 h-16 flex items-center justify-center">
                  <div className="-rotate-45">
                    <img src={selectedImage} alt="Service Icon" />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="md:p-6 p-2 text-center">
                <h3 data-aos="fade-up" data-aos-duration="700" className="text-2xl font-semibold familjen-font my-2 line-clamp-1 mb-4">
                  {service.title}
                </h3>
                <p data-aos="fade-up" data-aos-duration="700" className="text-sm md:text-[1rem] font-normal leading-relaxed max-w-2xl text-[#5a5a5a] my-4">
                  {service?.description?.length > 50
                    ? service.description.substring(0, 50) + "..."
                    : service?.description}
                </p>

                <button data-aos="fade-up" data-aos-duration="700"
                  onClick={() => handleReadMore(service._id)}
                  className="mx-auto font-semibold familjen-font flex items-center gap-2 mb-6 text-primabg-primaryColor hover:text-blue-800 transition-colors"
                >
                  READ MORE
                  <FaArrowRightLong />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Services;
